module.exports = __webpack_public_path__ + "media/audio6.b2e8dbd7.mp3";